<template>
  <div>
    <div class="tabs">
      <div class="tab-item" :class="index === 0 ? 'active' : ''" @click="tapFn(0)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" alt="">
        SPBCN×个人赛
      </div>
      <div class="tab-item" :class="index === 1 ? 'active' : ''" @click="tapFn(1)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon7.png" alt="">
        ITSO×团体赛
      </div>
      <div class="tab-item" :class="index === 2 ? 'active' : ''" @click="tapFn(2)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon4.png" alt="">
        CEBSB×汉英双拼
      </div>
      <div class="tab-item" :class="index === 3 ? 'active' : ''" @click="tapFn(3)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon8.png" alt="">
        NASCC×北美冠军挑战赛
      </div>
      <div class="tab-item" :class="index === 4 ? 'active' : ''" @click="tapFn(4)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon9.png" alt="">
        ASBC×亚洲杯
      </div>
      <div class="tab-item" :class="index === 5 ? 'active' : ''" @click="tapFn(5)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon10.png" alt="">
        WSA×拼词世界杯
      </div>
      <div v-if="type === 1" class="tab-item" :class="index === 6 ? 'active' : ''" @click="tapFn(6)">IBC</div>
      <div class="tab-add-btn" @click="handleAdd">
        <i class="el-icon-plus"></i> 添加产品
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyComponent',
  props: {
    index: {
      type: Number
    },
    type: {
      type: Number
    }
  },
  methods: {
    tapFn (index) {
      console.log(index)
      if (this.type === 1) {
        if (index === 0) {
          this.$router.push('/individual_manage_homeview/individual_race_management')
        } else if (index === 1) {
          this.$router.push('/raceManagement/team_management/team_race_management')
        } else if (index === 6) {
          this.$router.push('/raceManagement/ibcHomeManagement')
        }
      } else if (this.type === 2) {
        this.$emit('tap', index)
      }
    },
    handleAdd () {
      this.$emit('add')
    }
  }
}
</script>

<style lang="less" scoped>
.tabs{
  display: flex;
  align-items: flex-end;
  .tab-item{
    // width: 200px;
    padding-left: 20px;
    padding-right: 20px;
    height: 36px;
    border-radius: 14px 14px 0 0;
    color: #000;
    background-color: #fff;
    font-size: 14px;
    margin-right: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo{
    width: 28px;
    height: 28px;
    margin-right: 4px;
    object-fit: contain;
    display: none;
  }
  .active{
    // width: 260px;
    padding-left: 30px;
    padding-right: 30px;
    background-color: #FAD54A;
    height: 44px;
    font-weight: bold;
    font-size: 16px;
    .logo{
      display: block;
    }
  }
  .tab-add-btn{
    width: 120px;
    height: 36px;
    background-color: #fcedb6;
    color: #000;
    border-radius: 14px 14px 0 0;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      background-color: #fbe491;
    }
  }
}
</style>
